<template>
  <div>
    <div class="title" :class="['title',loading ?'has-loading':'']" v-if="OrderInfo">订单详情</div>
    <div class="no-data" v-if="loading">
      <div class="small_loading">
        <img src="https://static.getconnectplus.com/tb_webassets/tb_small_loading.gif" />
      </div>
    </div>

    <template v-else>
      <history-order-detail v-if="orderType" :orderInfo="OrderInfo" :showDetail="showDetail"></history-order-detail>
      <order-detail
        v-else
        @cancelOrder="canCelOrder"
        @goPayorderdetail="goPayorderdetail"
        :orderInfo="OrderInfo"
        :showDetail="showDetail"
      ></order-detail>
    </template>
    <pay-pop
      :paymethod="paymethod"
      :showPay="showPay"
      v-on:close="close"
      @goPay="goPay"
      @payMethod="payMethod"
    ></pay-pop>
    <pay ref="pay" :money="$utils.toThousands(payAmount)" @paysuccess="paysuccess"></pay>
  </div>
</template>

<script>
import OrderDetail from "../components/common/OrderDetail";
import HistoryOrderDetail from "../components/common/HistoryOrderDetail";
import PayPop from "../components/common/PayPop";
import Pay from "../components/common/Pay.vue";
import countDown from "../components/common/countDown.vue";
export default {
  data() {
    return {
      showPay: false,
      showDetail: false,
      API: this.$store.state.API,
      paymethod: 0, //0代表支付宝1代表微信
      payAmount: 0, //当前待支付订单需要支付的金额
      orderId: "",
      orderType: "",
      loading: true,
      iscancle: false,
      OrderInfo: null
    };
  },
  watch: {
    $route: function(newVal, oldVal) {
      // this.getOrderList();
    }
  },
  components: { OrderDetail, PayPop, Pay, countDown, HistoryOrderDetail },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    document.title = "订单" + this.$store.state.titleSuffix;
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.paymethod = 1;
    }
    this.$store.commit("setValue", ["showOrderDetail", true]);
    this.orderId = this.$route.query.id;
    this.orderType = this.$route.query.tab;
    if (this.orderType == "history") {
      this.getHistoryDetail(this.orderId);
    } else {
      this.getOrderDetail(this.orderId);
    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.$gaAction.pageview(document.title, this.$route.path);
  },
  destroyed() {},
  computed: {
    isClickAcount() {
      return this.$store.state.isClickAcount;
    }
  },
  watch: {
    isClickAcount(curVal, oldVal) {
      this.showDetail = false;
      this.currentPage = 1;
    }
  },
  methods: {
    goRouter(_r) {
      this.$router.push({ path: _r });
    },

    cancle(id, index) {
      this.chooseindex = index;
      this.iscancle = true;
    },
    async canCelOrder(id, index) {
      let url = this.API.order.cancelOrder;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      let params = {
        openId: OpenId || this.$store.state.userId,
        orderId: id,
        formId: "12"
      };

      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.orderList[index].status = 4;
            this.iscancle = false;
            this.getOrderDetail(this.orderId);
            this.$Message.success("取消订单成功");
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => []);
    },
    goOrderList() {
      if (this.showDetail) {
        this.showDetail = false;
      }
    },

    paysuccess() {
      this.isConfirmLeave = true;
      this.getOrderDetail(this.orderId);
    },
    payMethod(e) {
      // 获得方式
      this.paymethod = e;
    },

    goPay(e) {
      this.showPay = false;
      let paywayTxt = "ALIPAY";
      if (this.paymethod == 1) {
        paywayTxt = "WECHAT";
      }
      this.$refs.pay.doPay(this.orderId, paywayTxt);
    },
    goPayorderdetail(e) {
      //从详情去付款
      this.showPay = true;
      this.payAmount = e.totalAmount;
      this.orderId = e.id;
      console.log(e, "详情付款");
    },
    goTocheckout(e) {
      console.log(e, "需付款的内容");
      this.showPay = true;
      this.payAmount = e.totalAmount;
      this.orderId = e.id;
    },
    getHistoryDetail(portalOrderNumber) {
      var that = this;
      this.showDetail = true;
      let url =
        this.API.order.getHistoryOrderDetail +
        "?portalOrderNumber=" +
        portalOrderNumber;
      this.$http.get(url, {}).then(res => {
        if (res.data.message == "success") {
          this.OrderInfo = res.data.returnData;
          if (this.OrderInfo.details.length == 0) {
            this.OrderInfo.details.push(res.data.returnData.order);
          }
        } else {
          this.$Message.error(res.data.message);
        }
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });
    },

    getOrderDetail(id) {
      this.showDetail = true;
      let url = this.API.order.orderDetail;
      let params = {
        orderId: id
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.OrderInfo = res.data.returnData;
            this.$utils.updateImgOssSuffix(this); //检测是否支持webp格式
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.$Message.error(res.data.message);
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        })
        .catch(err => {});
    },
    close() {
      this.showPay = false;
    }
  }
};
</script>
<style>
.nav-content {
  border: none;
}
</style>
<style lang="less" scoped>
.title {
  padding: 2rem;
  border: 0.1rem solid #eaeaea;
  border-bottom: none;

  &.has-loading {
    // border-bottom: 0.1rem solid #eaeaea;
  }
}
.no-data {
  // border-top: none;
  border: 0.1rem solid #eaeaea;
  // border: 0.1rem solid #eaeaea;
  // padding-top: 2rem;
  // padding-bottom: 2rem;
}

.order-container {
  // border: none;
}
.order-detail-container {
  border: 1px;
  .order-info {
    border: 0.1rem solid #eaeaea;
    .order-base-info {
      display: flex;
      padding: 3rem 2rem;
      border-bottom: 0.1rem solid #eaeaea;
      .order-base-receive {
        width: 40%;
      }
      .info {
        padding-top: 2rem;
        .delivery-detail {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    .order-create-info {
      padding: 3rem 2rem;
      display: flex;
      border-bottom: 0.1rem solid #eaeaea;
      margin-bottom: 2rem;
      .item {
        width: 25%;

        &.order-stauts {
          // width: 50%;
          .item-value {
            display: flex;
          }
        }
        .herf_tilte {
          cursor: pointer;
        }
        .go-pagy {
          display: flex;
          .del-tips {
            padding-left: 0.7rem;
          }
        }
      }
    }
  }

  .pay-info {
    text-align: right;
    padding: 1.5rem 0 10rem;
    width: 30%;
    float: right;
    .pay-info-item {
      display: flex;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: space-between;
    }
  }
}

@media screen and (max-width: 768px) {
  .good-list .cart-item .cart-left .cart-img {
    flex: 2;
  }
  .order-detail-container .order-info .order-base-info .order-base-receive {
    width: 50%;
  }
  .order-detail-container .order-info .order-create-info .item {
    &.order-no {
      width: 40%;
    }
  }

  .order-detail-container
    .order-info
    .order-create-info
    .item.order-stauts
    .item-value {
    flex-direction: column;
  }
  .order-detail-container .pay-info {
    padding: 1.5rem 2rem 10rem;
    width: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderDetail.vue